(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity-react/assets/react/pages/integrity/integrity.js') >= 0) return;  svs.modules.push('/modules/terms-integrity-react/assets/react/pages/integrity/integrity.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.termsIntegrity.logger;
const _svs$termsIntegrity$s = svs.termsIntegrity.sharedComponents,
  Footer = _svs$termsIntegrity$s.Footer,
  MainPage = _svs$termsIntegrity$s.MainPage,
  TopMenu = _svs$termsIntegrity$s.TopMenu;
const _svs$termsIntegrity$s2 = svs.termsIntegrity.sharedComponents,
  useGetCmsDataDocument = _svs$termsIntegrity$s2.useGetCmsDataDocument,
  useGetCmsDataFolder = _svs$termsIntegrity$s2.useGetCmsDataFolder;
const _svs$termsIntegrity$s3 = svs.termsIntegrity.sharedComponents,
  DocList = _svs$termsIntegrity$s3.DocList,
  FaqList = _svs$termsIntegrity$s3.FaqList;
const Integrity = () => {
  const _React = React,
    useState = _React.useState,
    useEffect = _React.useEffect;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    docUrl = _useState2[0],
    setDocUrl = _useState2[1];
  const faqPersonDataFolderId = ReactRedux.useSelector(state => state.termsIntegrity.faqPersonDataFolderId);
  const personDataFolderId = ReactRedux.useSelector(state => state.termsIntegrity.personDataFolderId);
  const _useGetCmsDataFolder = useGetCmsDataFolder(faqPersonDataFolderId),
    faqData = _useGetCmsDataFolder.data,
    faqLoading = _useGetCmsDataFolder.loading,
    faqDataError = _useGetCmsDataFolder.dataError;
  const _useGetCmsDataFolder2 = useGetCmsDataFolder(personDataFolderId),
    docData = _useGetCmsDataFolder2.data,
    docLoading = _useGetCmsDataFolder2.loading,
    docDataError = _useGetCmsDataFolder2.dataError;

  const personDataDoc = ReactRedux.useSelector(state => state.termsIntegrity.personDataDoc);
  const _useGetCmsDataDocumen = useGetCmsDataDocument(personDataDoc),
    docSvSData = _useGetCmsDataDocumen.data;
  useEffect(() => {
    var _svs;
    const cdn = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.cdn2;
    if (docSvSData && docSvSData.length > 0) {
      logger.debug('useEffect to get specific dokument...');
      if (docSvSData[0].documentUrl) {
        const url = cdn + docSvSData[0].documentUrl;
        setDocUrl(url);
      }
    }
  }, [docSvSData]);
  return React.createElement(React.Fragment, null, React.createElement(TopMenu, null), React.createElement(MainPage, null, React.createElement("h2", null, "S\xE5 h\xE4r hanterar vi dina personuppgifter"), React.createElement("div", {
    className: "margin-xs-top-1"
  }, React.createElement("p", null, "Du ska vara trygg n\xE4r du anf\xF6rtror dina personuppgifter till Svenska Spel. Nedan finner du en sammanfattning om hur vi behandlar dessa. I", ' ', React.createElement("a", {
    className: "fc-sport-75",
    href: docUrl,
    rel: "noreferrer",
    target: "_blank"
  }, "Svenska Spels information om behandling av personuppgifter"), ' ', "hittar du en fullst\xE4ndig information i enlighet med dataskyddsf\xF6rordningens krav.", React.createElement("br", null), React.createElement("a", {
    className: "fc-sport-75",
    href: "https://business.safety.google/privacy/",
    rel: "noreferrer",
    target: "_blank"
  }, "Du kan \xE4ven l\xE4sa mer om hur Google behandlar personliga uppgifter."))), React.createElement("div", {
    className: "margin-xs-top-1 unstyled-nav"
  }, faqDataError && React.createElement("div", null, "Fel vid h\xE4mtning av FAQ"), faqLoading && React.createElement("div", null, "Laddar faq data..."), faqData && faqData.length > 0 && React.createElement(FaqList, {
    faqList: faqData
  })), React.createElement("div", {
    className: "margin-xs-top-4"
  }, docDataError && React.createElement("div", null, "Fel vid h\xE4mtning av dokument"), docLoading && React.createElement("div", null, "Laddar dokument..."), docData && docData.length > 0 && React.createElement(DocList, {
    docList: docData
  }))), React.createElement(Footer, null));
};
svs.termsIntegrity.integrity.Integrity = Integrity;

 })(window);